export default function ElectricityIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_696" data-name="Rectangle 696" width="11.476" height="13.851" transform="translate(0 0)" fill="#fff" />
        </clipPath>
      </defs>
      <rect id="Rectangle_704" data-name="Rectangle 704" width="37" height="37" rx="18.5" opacity="0" />
      <g id="Group_1938" data-name="Group 1938" transform="translate(12.275 10.652)">
        <g id="Group_1938-2" data-name="Group 1938" transform="translate(0 0)" clipPath="url(#clip-path)">
          <path
            id="Path_1236"
            data-name="Path 1236"
            d="M3.426,13.851a.35.35,0,0,1-.321-.49L5.264,8.4H.35A.35.35,0,0,1,.1,7.8L7.8.1A.35.35,0,0,1,8.372.49L6.212,5.45h4.914a.35.35,0,0,1,.247.6l-7.7,7.7a.35.35,0,0,1-.248.1"
            transform="translate(0 0)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
